
import Vue from 'vue';

export default Vue.extend({
  name: 'IconButton',
  props: {
    icon: { type: String, required: false },
    tooltip: { type: String, required: true },
    color: { type: String, required: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  methods: {
    click(e: Event) {
      this.$emit('click', e);
    },
  },
});

